// PE-A4d (después de M39-bis): company_sso_profile.workers_count es el número DECLARADO en el Perfil SSO (lo usa la
// normativa) y workers_registered_count el de trabajadores registrados en StorSafe (activo o licencia; lo mantiene
// workers_count_trigger). La página Trabajadores los compara con un aviso que no bloquea nada.

export interface WorkerConEstado { status: string | null }

// Mismo criterio que el trigger de M39-bis: 'activo' y 'licencia' siguen siendo trabajadores de la empresa;
// 'desvinculado' no cuenta.
export const ESTADOS_REGISTRADOS = ['activo', 'licencia'] as const;
export const contarRegistrados = (ws: WorkerConEstado[]) =>
  ws.filter(w => (ESTADOS_REGISTRADOS as readonly string[]).includes(w.status ?? '')).length;

export type TipoAviso = 'info' | 'actualizar' | 'sin_declarado';
export interface AvisoRegistrados { tipo: TipoAviso; texto: string; sugerencia?: string }

export function avisoRegistrados(registrados: number, declarados: number | null | undefined): AvisoRegistrados {
  const n = (k: number) => `${k} trabajador${k === 1 ? '' : 'es'}`;
  if (declarados === null || declarados === undefined || declarados <= 0) {
    return {
      tipo: 'sin_declarado',
      texto: `Registraste ${n(registrados)}, pero tu Perfil SSO no tiene el número de trabajadores declarados.`,
      sugerencia: 'Complétalo en el Perfil SSO: de ese número dependen las obligaciones del Checklist.',
    };
  }
  const texto = `Registraste ${registrados} de ${declarados} trabajador${declarados === 1 ? '' : 'es'} declarado${declarados === 1 ? '' : 's'} en tu Perfil SSO.`;
  if (registrados > declarados) {
    return { tipo: 'actualizar', texto, sugerencia: 'Registraste más de los que declaraste: actualiza el número en el Perfil SSO.' };
  }
  return { tipo: 'info', texto };
}
